module.exports = __webpack_public_path__ + "static/media/FoodBack.3e81aa74.png";